<script>
import {getEmployeeSetting, setSystemSettingInfo} from "@/api/setting-api";

export default {
  name: "VisitorSettingPage",
  data() {
    return {
      activeName: "first",

      form1: {
        workId: 1,
        workIdShow: "showTypePart",
        workIdSearch: "searchTypeFull",
        phoneNo: 2,
        phoneNoShow: "showTypePart",
        phoneNoSearch: "searchTypeFull",
        nameSearch: "searchTypeFull",
        searchEmployeeBy: "ALL",
        emailSuffix: "",
      },
      rules1: {
        workId: [
          {required: true, message: '请选择员工工号是否展示', trigger: 'change'},
        ],
        phoneNo: [
          {required: true, message: '请选择员工手机号是否展示', trigger: 'change'},
        ],
      },

    }
  },// end of data

  mounted() {
    this.requiredForm1()
  },

  methods: {
    onTabChange() {
      if (this.activeName === "first") {
        this.requiredForm1()
      }
    },
    requiredForm1() {
      getEmployeeSetting().then(({data}) => {
        console.log("getEmployeeConfigSetting", data)
        if (data.code === 200) {
          data.data.forEach(item => {
            if (item.type === "UNIVERSAL") {
              let content = JSON.parse(item.content)
              if (content) {
                this.form1.workId = content.workId
                this.form1.phoneNo = content.phoneNo
                if (content.workId === 2) {
                  this.form1.workIdSearch = content.workIdSearch
                  this.form1.workIdShow = content.workIdShow
                }
                if (content.phoneNo === 2) {
                  this.form1.phoneNoShow = content.phoneNoShow
                  this.form1.phoneNoSearch = content.phoneNoSearch
                }
                if (content.nameSearch) {
                  this.form1.nameSearch = content.nameSearch
                }
                if (content.searchEmployeeBy) {
                  this.form1.searchEmployeeBy = content.searchEmployeeBy
                }
                if (content.emailSuffix) {
                  this.form1.emailSuffix = content.emailSuffix
                }
              }
            }
          })
        }
      })
    },

    onSubmitForm1() {
      let content = {
        workId: this.form1.workId,
        phoneNo: this.form1.phoneNo,
        nameSearch: this.form1.nameSearch,
        searchEmployeeBy: this.form1.searchEmployeeBy,
        emailSuffix: (this.form1.emailSuffix || "").trim()
      }
      if (this.form1.workId === 2) {
        content.workIdShow = this.form1.workIdShow
        content.workIdSearch = this.form1.workIdSearch
      } else {
        content.workIdShow = ""
        content.workIdSearch = ""
      }
      if (this.form1.phoneNo === 2) {
        content.phoneNoShow = this.form1.phoneNoShow
        content.phoneNoSearch = this.form1.phoneNoSearch
      } else {
        content.phoneNoShow = ""
        content.phoneNoSearch = ""
      }
      this.$refs.form1.validate((valid) => {
        if (valid) {
          const postData = {
            target: "EMPLOYEEINFO",
            type: "UNIVERSAL",
            content: JSON.stringify(content),
            state: "VALID"
          }
          setSystemSettingInfo(postData).then(({data}) => {
            if (data.code === 200) {
              this.$message.success("保存成功")
            } else {
              this.showServerErrMsg(data)
            }
          }).catch((err) => {
            this.showNetErrMsg(err)
          })
        }
      });
    },
  }, // end of methods
}
</script>

<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="onTabChange">
      <el-tab-pane label="字段设置" name="first">
        <el-form :model="form1" :rules="rules1" ref="form1" class="demo-ruleForm">
          <h4>员工工号</h4>
          <el-form-item label="" prop="workId">
            <el-radio-group v-model="form1.workId">
              <el-radio :label="1" border>不展示</el-radio>
              <el-radio :label="2" border>展示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="展示方式" prop="workIdShow" v-if="form1.workId === 2">
            <el-radio-group v-model="form1.workIdShow">
              <el-radio label="showTypeFull">明文展示</el-radio>
              <el-radio label="showTypePart">脱敏展示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="搜索方式" prop="workIdSearch" v-if="form1.workId === 2">
            <el-radio-group v-model="form1.workIdSearch">
              <el-radio label="searchTypeFull">完整查询</el-radio>
              <el-radio label="searchTypePart">模糊查询</el-radio>
            </el-radio-group>
          </el-form-item>
          <h4>员工手机</h4>
          <el-form-item label="" prop="phoneNo">
            <el-radio-group v-model="form1.phoneNo">
              <el-radio :label="1" border>不展示</el-radio>
              <el-radio :label="2" border>展示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="展示方式" prop="phoneNoShow" v-if="form1.phoneNo === 2">
            <el-radio-group v-model="form1.phoneNoShow">
              <el-radio label="showTypeFull">明文展示</el-radio>
              <el-radio label="showTypePart">脱敏展示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="搜索方式" prop="phoneNoSearch" v-if="form1.phoneNo === 2">
            <el-radio-group v-model="form1.phoneNoSearch">
              <el-radio label="searchTypeFull">完整查询</el-radio>
              <el-radio label="searchTypePart">模糊查询</el-radio>
            </el-radio-group>
          </el-form-item>
          <h4>员工姓名</h4>
          <el-form-item label="搜索方式" prop="nameSearch">
            <el-radio-group v-model="form1.nameSearch">
              <el-radio label="searchTypeFull">完整查询</el-radio>
              <el-radio label="searchTypePart">模糊查询</el-radio>
            </el-radio-group>
          </el-form-item>

          <h4>被访员工查找方式（访客预约）</h4>
          <el-form-item label="">
            <el-radio-group v-model="form1.searchEmployeeBy">
              <el-radio label="ALL">默认（姓名/手机号）</el-radio>
              <el-radio label="EMAIL">仅邮箱（邮箱为唯一验证字段）</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form1.searchEmployeeBy === 'EMAIL'" label="邮箱后缀">
            <el-input v-model="form1.emailSuffix" placeholder="如 @beigene.com，留空则访客需输入完整邮箱" style="width: 320px" />
            <div class="el-form-item__tip" style="font-size: 12px; color: #999; line-height: 1.6">
              配置后访客端搜索框固定展示该后缀，访客只输入前缀即可搜索；企业更换邮箱域名时改这里即可
            </div>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmitForm1">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style scoped lang="less">

</style>
